import React from "react";

type BidHistory = {
  id: number;
  amount: number;
  created_at: string;
  is_highest: boolean;
  bidder_name: string | null;
};

type Props = {
  bidHistories: BidHistory[];
  emptyMessage?: string;
};

const formatDateTime = (iso: string): string => {
  const d = new Date(iso);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${yyyy}/${mm}/${dd} ${hh}:${min}`;
};

const AuctionBidHistoriesList: React.FC<Props> = ({ bidHistories, emptyMessage }) => {
  if (!bidHistories || bidHistories.length === 0) {
    return (
      <p className="text-sm text-[#768084] text-center py-4">
        {emptyMessage || "まだ入札はありません"}
      </p>
    );
  }

  return (
    <div className="max-h-[200px] overflow-y-auto border border-[#D2DFE6] rounded text-left">
      <ul className="divide-y divide-[#D2DFE6]">
        {bidHistories.map((bid) => (
          <li
            key={bid.id}
            className={`flex justify-between items-center px-3 py-2 text-sm ${bid.is_highest ? "bg-[#E6F0FA]" : ""}`}
          >
            <span className="text-[#768084] text-xs sm:text-sm">
              {formatDateTime(bid.created_at)}
            </span>
            <span className="text-xs sm:text-sm">{bid.bidder_name || "(匿名)"}</span>
            <span className={`font-bold ${bid.is_highest ? "text-[#006AC9]" : ""}`}>
              {bid.amount.toLocaleString()}円
              {bid.is_highest && <span className="ml-1 text-xxs">(最高)</span>}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AuctionBidHistoriesList;
